import React from "react";
import { Redirect } from "react-router-dom";
import { Grid } from "semantic-ui-react";
import styled from "styled-components";
import { Constants } from "../Constants";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import SFCookieConsent from "./common/SFCookieConsent";
import SFLoader from "./common/SFLoader";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import TestCard from "./common/TestCard";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

class MySafeWindow extends BaseComponent {
  constructor() {
    super();
    this.state = {
      consumer: null,
      showLoading: false,
    };
    this.getConsumer = this.getConsumer.bind(this);
  }

  async componentDidMount() {
    this.setState({ showLoading: true });
    await this.getConsumer();
    this.setState({ showLoading: false });
  }

  async getConsumer() {
    if (!(await this.checkLogin())) {
      return;
    }

    this.setState({ showLoading: true });
    try {
      const response = await this.safeFunApi.getCurrentUser();
      this.setState({ consumer: response.data });
    } catch (err) {
      console.log(err);
      this.errorManager.addError(err.toString());
      this.forceUpdate();
    }
    this.setState({ showLoading: false });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="My Safe Window" />
        <SFLoader active={this.state.showLoading} />
        <MainContentWrapper>
          <TabBar safewindow />

          <Wrapper>
            <Grid columns={1} style={{ width: "400px", margin: "0" }}>
              <Grid.Row>
                <Grid.Column style={{ margin: "0", padding: "0" }}>
                  {this.state.consumer ? (
                    <TestCard currentUser consumer={this.state.consumer} />
                  ) : null}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column style={{ textAlign: "center" }}>
                  <a
                    href={Constants.TESTING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Click to learn more about our testing
                    <br /> philosophy and SafeWindows
                  </a>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default MySafeWindow;
